module.exports = __webpack_public_path__ + "assets/images/JMD5000.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/JMD5000.png
// module id = 1389
// module chunks = 1